export function getDiffDate(date_start, date_end?) : number {
  date_start = new Date(date_start);

  if (date_end == '' || date_end == null || date_end == undefined)
    date_end = new Date();
  else
    date_end = new Date(date_end);

  const diff = date_end.getTime() - date_start.getTime();  //msec
  return Math.ceil(diff / (1000 * 3600 * 24));
}

export function getDiffDateDisabilty(date_start, date_end?): number {
  date_start = new Date(date_start);

  if (date_end == '' || date_end == null || date_end == undefined)
      date_end = new Date();
  else
      date_end = new Date(date_end);

  const diff = date_end.getTime() - date_start.getTime();
  return Math.ceil(diff / (1000 * 3600 * 24)) + 1;  // Sumamos 1 para contar el día de inicio
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/functions/getDiffDate.function.ts